import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import WistiaVideo from './Videos.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    instructionList: { 
        paddingTop: '10px',
        listStyleType: 'disc',
    },
    instructionListItem: { 
        paddingTop: '10px',
    },
    introText: { 
        fontSize: '24px',
        lineHeight: '26px',
        marginBottom: '10px',
    }
}
class Privacy extends Component{

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Privacy Policy | Edit My Paper</title>
                    <link rel="canonical" href="https://editmypaper.ca/privacy" />
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div className="steps-container">
                        <h2 style={styles.localH2}>Privacy Policy - EditMyPaper.ca</h2>
                        <div className="privacy-content">
                            <p><strong>Does Edit My Paper collect any information?</strong></p>
                            <p>Edit My Paper collects the information an editor or client provides during editing transactions, registration or providing relevant academic records in order to facilitate solely an editing transaction, newsletter email or internal auditing. 

                                <br/><br/>Edit My Paper collects and stores for a limited amount of time any paper uploaded in order to complete the transaction and for possible disputes.  All information and documents are stored securely. 

                                <br/><br/>Editing transactions and registration of editors involves the collection of any information deemed necessary, all of which you will be asked for prior to collection.  Browsing the site does not involve the collection of any information unless you fill out a form, register or conduct an editing transaction. All financial information such as credit card information is processed via Stripe.com which is handled by Stripe's SSL encryption.  Edit My Paper does not store any credit card information as it is processed on Stripe's side and subject to their Terms of Service.                                     
                            </p>
                            <p><strong>How is your information used?</strong></p>
                            <p>
                                Basic information such as first or last names may be used for email purposes, editor auditing or transaction records.   All information is processed via SSL encryption and is stored securely.  Editors or potential editors can request any formal copy of academic records provided for registration to be erased once the editor has completed verification.  By accepting our Privacy Policy you may be placed on our email list as en editor or as a student. We only send out important updates or promotions for students. To unsubscribe simply email at info @ editmypaper.ca.

                                <br/><br/>Information and documents collected may be used for the following purposes, but not limited to:
                            </p>
                            <ol>
                                <li>To enhance and customize emails, editing opportunities or general communication between Edit My Paper and yourself</li>
                                <li>To conduct audits or resolve disputes.</li>
                                <li>To conduct editing transactions and provide relevant information via email, telephone, or other methods of communication in the event of a dispute.</li>
                                <li>To provide customer service or communications via email, telephone or direct mail.  Updates, potential editing jobs or other information about Edit My Paper may be communicated via email and be personalized with the information you provided.   Unsubscribing to any email notification is easy and located at the bottom of every email (or you may reply to that email telling us what you would like to do).</li>
                                <li>Documents uploaded are only distributed to the editor that accepts the editing job based on the editing criteria such as number of pages, time limit, and remuneration. In the event the editor is unable to complete the editing job within the specified amount of time another editor may access to your document to complete or restart the editing process.</li>
                                <li>Documents as stored internally and NEVER sold, distributed outside of the service you requested, or traded, unless a dispute has arisen.  All editors are to adhere to the same privacy policy clients adhere to and are to never use, sell, trade or distribute any essay they edit.</li>
                            </ol>                                
                            <p><strong>Do we protect your information?</strong></p>
                            <p>
                                We utilize SSL encryption and adhere to a strict internal password policy.  Credit Card information is sent via an encrypted connection direct to Stripe and protected with Stripe's encryption.  All personal information is kept confidential.  Editors and clients NEVER are provided with each other's information.  We have electronic countermeasures to ensure that personal information is kept out of documents uploaded for editing.  Client's information is never distributed to the editor.                                    
                            </p>

                            <p><strong>Do we use internet cookies?</strong></p>
                            <p>
                                Cookies are used to personalize your web experience in order to have our computers 'remember' if you had begun any transaction or inquiry.  Cookies retain basic information about what links you look at on our website in order to benefit your browsing experience and help us build on what our clients find most helpful.  Cookies are also used to tailor relevant ads.                                 
                            </p>

                            <p><strong>Is your information ever released outside of Edit My Paper?</strong></p>
                            <p>
                                Your information is not disclosed, distributed, or sold to any outside party.  The only parties that have access to your information is Edit My Paper.
                                The information in a client's document to be edited is disclosed to facilitate the editing process to the editor(s) involved.
                                Some third parties may be contracted by Edit My Paper to audit, enhance or assist Edit My Paper in our day to day operations.
                                <br/><br/> Any third party must adhere to our strict privacy and confidentiality agreements put in place.
                                If law enforcement provides a court order for your information, it may be released to cooperate with any proceedings, enforce our Terms of Service, or other pertinent issues. 
                                Only information that is available at the time of request will be released and clients or editors will usually be promptly notified if any information is released.
                                Cookies may be used in conjunction with any advertising, but none of the information will be disclosed to the public.
                            </p>

                            <p><strong>Do we link to outside sites?</strong></p>
                            <p>
                                From time to time we may link to outside sites in order to provide additional services or information. You are responsible to view their Terms of Service and/or privacy policies as well as adhere to them when using outside, third party services.                                     
                            </p>

                            <p><strong>Fighting Internet and Wireless Spam Bill C-28</strong></p>
                            <p>
                                Edit My Paper strives to adhere to all online and offline privacy, spam and commerce laws in the Province of Ontario.                                     
                            </p>

                            <p><strong>Edit My Paper’s Privacy Policy</strong></p>
                            <p>
                                Our online privacy policy and terms of service applies to online activity on <a href="/">editmypaper.ca</a>                                    
                            </p>

                            <p><strong>Your Consent </strong></p>
                            <p>
                                By visiting and conducting a transaction with Edit My Paper or its editors, you agree to our Terms of Service and Privacy Policy.                                     
                            </p>

                            <p><strong>Amending our Privacy Policy</strong></p>
                            <p>
                                Our Privacy Policy may be updated periodically to which you will be notified about if it will critically impact you.  Any new changes will allow you to agree or opt out of any changes and can be further discussed by contacting us.
                                This policy was last modified on February 2, 2014                                    
                            </p> 
                            <p><strong>Please Contact Us</strong></p>
                            <p>We are available via email to clarify any part of our website or Privacy Policy and Terms of Service at: <a href="https://editmypaper.ca" target="_blank">editmypaper.ca</a></p>
                        </div>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}
export default connect(
)(Privacy);



// WEBPACK FOOTER //
// ./src/components/pages/Privacy.js